import { Component, inject, Inject, OnInit, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { gungComparatorHelper } from 'gung-common';
import { first, forkJoin, of, switchMap } from 'rxjs';
import { FeatureActivatedGuardWrapper } from '../../guards/feature-activated/feature-activated.guard';
import { Customer } from '../../models';
import { NavigationConfig } from '../../models/navigation-config';
import { AuthService } from '../../services/auth/auth.service';
import { CustomerActionConfigService } from '../../services/customer-action-config.service';
import { CustomerDetailsConfigService, CustomerDetailsTab } from '../../services/customer-details-config/customer-details-config.service';
import { CustomerService } from '../../services/customers/customer.service';
import { NavbarConfigService } from '../../services/navbar-config/navbar-config.service';

@Component({
    selector: 'lib-customer-details',
    templateUrl: './customer-details.component.html',
    styleUrls: ['./customer-details.component.css'],
    standalone: false
})
export class CustomerDetailsComponent implements OnInit {
  public actionConfigStandardService = inject(CustomerActionConfigService);
  protected route = inject(ActivatedRoute);
  protected customerService = inject(CustomerService);
  protected authService = inject(AuthService);
  protected navbarConfigService = inject(NavbarConfigService);
  protected featureActivatedGuardWrapper = inject(FeatureActivatedGuardWrapper);
  protected customerDetailsConfigService = inject(CustomerDetailsConfigService);

  customer: Customer;
  isUser = false;
  isSalesOrAdmin = false;
  showActivities = this.navbarConfigService.enableCustomerActivities;

  public enableOffers = this.environment?.enableOffers;

  customerDetailsTabs: CustomerDetailsTab[] = [];

  

  constructor(
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig
  ) {}

  ngOnInit() {
    const routeParams = this.route.snapshot.params;
    if (routeParams.customerId != null) {
      this.authService.getCurrentUser().pipe(
        first(),
        switchMap(user => forkJoin({
          user: of(user),
          roles: this.authService.getRoles().pipe(first()),
          customer: this.customerService.getCustomer(routeParams.customerId).pipe(first())
        }))
      ).subscribe(({ user, roles, customer }) => {
        this.isUser = roles.includes('USER') && roles.length === 1;
        this.isSalesOrAdmin = roles.indexOf('ADMIN') !== -1 || roles.indexOf('SALES') !== -1;
        this.customer = structuredClone(customer);
        this.customerDetailsConfigService.getCustomerDetailsGungTabs(customer, roles, user).pipe(first()).subscribe(res => {
          this.customerDetailsTabs = res.sort((a, b) => gungComparatorHelper(a.sort || 0, b.sort || 0, 1));
          this.runErpFunctions();
        });
      });
    }
  }

  runErpFunctions(): void {

  }
}
